import styled from "styled-components";
const StepperStyle = styled.div`
.uploaded-file-container {
    max-height: 71px;
    overflow: auto;
    min-height: 71px;
}
    .stepper-steps{
        /* margin-left: -138px;
        margin-right: -138px; */
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .MuiStep-horizontal{flex:none;}
        .MuiStep-root.MuiStep-horizontal.steps.MuiStep-alternativeLabel.MuiStep-completed .MuiStepLabel-alternativeLabel > div {
            background: green;
            border: none;
        }
        .MuiStepConnector-root.MuiStepConnector-horizontal.css-ro94x-MuiStepConnector-root {
        width: 331px;
        position: absolute;
        left: -322px;
        top: 6px;
    }
        span{
            margin: 0;
        }
        .MuiStepper-root{
        }
        .drawer-fullwidth &{
            /* margin-left: 140px;
            margin-right: 153px; */
        }
        .MuiStepLabel-label{
            color:#000000E0;
            font-size: 14px;
            margin-top: 4px;
            font-weight: 600;
            line-height: 18px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;

            /* margin-top: 16px; */
            &.Mui-active{
                color:black;
            }
        }
        /* .MuiStepConnector-line{
            position: relative;
            left: -49%;
            width: 93%;
            top: 7px;
        } */
    }
    .upload-step{
        margin-top:11px;
        .step-title{
            text-align:center;
            display: block;
            /* margin-bottom:24px; */
            
            font-size: ${({theme})=> theme['base-font-size-small']};
            line-height:14px;
            padding-top:11px;
            a{
                margin-left:2px;
            }
        }

        .info{
            display: flex;
            flex-direction:column;
            /* margin-bottom:11px; */
            &.add-left-spacing {
                /* padding-left:2px; */
            }
            span{
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: #000000;
            }
            /* span:first-child{
                color:${({ theme }) => theme["regent_gray"]};
                font-size:${({ theme }) => theme["base-font-size-small"]};
            } */
            span:nth-child(2){
                color:#000; 
                font-size:${({ theme }) => theme["medium-font-size"]};  
                margin-top:0px;
            }
        }

        .switch-button{
            background: #FFFFFF;
            border: 1px solid #E6E6E6;
            padding: 8px;
            border-radius: 8px;
            display:grid;
            grid-template-columns: 1fr 1fr;
            margin-top:4px;
            grid-gap: 8px;
            .button{
                display: flex;
                align-items:center;
                justify-content:center;
                padding: 2px;
                font-size: 10px;
                font-weight: 600;
                line-height: 24px;
                border-radius: 4px;
                font-size:${({ theme }) => theme["base-font-size-small"]};
                &.in-active {
                    background: #EFF6F7;
                    font-family: Titillium Web;
                    text-align: left;
                    text-underline-position: from-font;
                    text-decoration-skip-ink: none;
                    color: #4E5969;
                }
                &.active{
                    background: #1565D8;
                    color:#fff;
                }
        
            }
        }
    }
    .step-mapping{
        label{
            font-size: ${({theme})=> theme['base-font-size-small']};
                line-height:12px;
            }
            input{
        
            }
            .position-relative.input-wrapper{
                line-height:12px;
            }
        .EZDrawer__container &{
            width: 100% !important;
        }
        .mapping-header-fields
        {
           margin-left:0px;
           padding-bottom:35px;
            ul{
                padding:0;
                margin:0;
                list-style: none;
                
                li{
                    width: 100%;
                    max-width: 291px;
                    margin-right:30px;
                }
            }
        }
        .mapping-header-options{
            margin-left:-1px;
            h3{
                margin-bottom:20px;
            }
            p.mapping-note{
                margin-top:24px;
                text-align:center;
                font-size: 13px;
                line-height: 16px;
                color:#757575;
                margin-bottom:54px;

            }
            .mapping-header-cols{
                padding-left:1px;
                flex-wrap: wrap;
            }
            .mapping-header-col{
                max-width:130px;
                min-width:130px;
                margin-right:30px;
                width:100%;
                .mapping-header{
                    margin-bottom: 19px;
                    input{
          
                    }
                    select{

                    }
                }
                ul{
                    padding-left: 14px;
                    li{
                        font-size:13px;
                        line-height:16px;
                        margin-bottom:17px;
                        color:#757575;
                    }
                }
            }
        }
        .btn{
            max-width:282px;
            margin:0 auto;
            display:block;
        } 
        .btn.disabled,.btn:disabled{
            background-color:${({theme})=> theme['base-font-size-small']};
            opacity: 1;
        }
        .modal{

        }
    }
    .step-congrats{
        text-align:center;
        padding-top:0px;
        max-width:417px;
        margin:0 auto;
        margin-top: -24px;
        position:relative;
        /* left:-3px; */
        .step-image{
            margin-block:48px;
        }
        h1{
            margin-bottom:30px;
            font-size:24px;
            font-family: "Titillium Web", sans-serif !important;
            font-weight:700;
            margin-left:-7px;
        }
        p{
            line-height:28px;
            color:${({theme})=> theme['boulder']};
            margin-bottom: 20px;
            font-size:14px;
            font-family: "Titillium Web", sans-serif !important;
            /* margin-left: -6px; */
        }
        .btn{
            max-width:272px;
            width:100%;
            margin:0 auto;
        }
    }
    
`;
export default StepperStyle;